import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Col, Modal, Row, Input, Typography } from 'antd';
import { CloseIcon, PressureIcon } from 'components/SvgIcon';
import DateChangeInModalComponent from 'pages/client/health_data/tabs/date_time/DateChangeInModalComponent';
import api from 'helpers/api.helper';
import { APP_URLS } from 'constants/url.constant';
import { showNormal } from 'helpers/notification.helper';
import HealthTypeEnum from 'enums/health_type.enum';

const CreatePressureModal = ({ value = {}, setValue, visible, onClose, onUpdate, getHealthPerType, isHealthList }) => {
    const { t } = useTranslation();

    const createPressureData = async (values, type) => {
        const response = await api.post(APP_URLS.CLIENT_HEALTH_DATA_CREATE, {
            value: value.pressure,
            ext_value: value.ext_pressure,
            created_at: value.created_at,
            health_images: [{ images: value.images, category: value.category }],
            // category: values.category,
            type,
        });
        if (response) {
            showNormal('', t('message:Data has been saved'), 3);
            getHealthPerType();
        }
    };

    return (
        <>
            <Modal
                title={
                    <>
                        <Row align={'middle'}>
                            <PressureIcon size={39} className="pr-8" />
                            {t('Blood Pressure')}
                        </Row>
                    </>
                }
                visible={visible}
                width={320}
                footer={null}
                closeIcon={<CloseIcon />}
                onCancel={() => onClose()}
                destroyOnClose={true}
            >
                <DateChangeInModalComponent value={value} setValue={setValue} />

                <Row gutter={0}>
                    <Col span={10}>
                        <Typography className="mt-16">{t('field:Maximum blood pressure')}</Typography>
                        <Input
                            className={
                                Number(value.ext_pressure) > Number(value.pressure)
                                    ? 'heath-data-modal-input pressure mr-6 border-validate'
                                    : 'heath-data-modal-input pressure mr-6'
                            }
                            value={value.pressure || null}
                            type="number"
                            min={0}
                            autoFocus={true}
                            onChange={e =>
                                setValue({
                                    ...value,
                                    pressure:
                                        Number(e.target.value) < 0
                                            ? Number(e.target.value) * -1
                                            : Number(e.target.value) <= 500
                                            ? Number(e.target.value)
                                            : null,
                                })
                            }
                        />
                        <span>/</span>
                    </Col>
                    <Col span={14}>
                        <Typography className="mt-16">{t('field:Minimum blood pressure')}</Typography>
                        <Input
                            className={
                                Number(value.ext_pressure) > Number(value.pressure)
                                    ? 'heath-data-modal-input pressure mr-6 border-validate'
                                    : 'heath-data-modal-input pressure mr-6'
                            }
                            value={value.ext_pressure || null}
                            type="number"
                            min={0}
                            onChange={ext =>
                                setValue({
                                    ...value,
                                    ext_pressure:
                                        Number(ext.target.value) < 0
                                            ? Number(ext.target.value) * -1
                                            : Number(ext.target.value),
                                })
                            }
                        />
                        <span>mmHg</span>
                    </Col>
                </Row>
                {Number(value.ext_pressure) > Number(value.pressure) && (
                    <p className="pressure-text-validation">{t('Please check your input again')}</p>
                )}

                <Button
                    type="primary"
                    block
                    className="mt-32 disable-gray-btn"
                    disabled={
                        !(value.pressure && value.ext_pressure) ||
                        value.pressure.length < 1 ||
                        value.ext_pressure.length < 1 ||
                        Number(value.ext_pressure) > Number(value.pressure)
                    }
                    onClick={values => {
                        isHealthList
                            ? createPressureData(values, HealthTypeEnum.PRESSURE.value).then(() => {})
                            : onUpdate && onUpdate(value);
                        setValue({ ...value, pressure: [], ext_pressure: [] });
                        onClose();
                    }}
                >
                    {t('Save')}
                </Button>
            </Modal>
        </>
    );
};

CreatePressureModal.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onUpdate: PropTypes.func,
    value: PropTypes.any,
    setValue: PropTypes.func,
    getHealthPerType: PropTypes.func,
};

export default CreatePressureModal;
